export const DEFAULT_ROWS = 1
export const DEFAULT_MAX_ROWS = 8
export const ROW_HEIGHT = 24
export const PADDING_VERTICAL = 20
export const PADDING_HORIZONTAL = 12
export const BASE_HEIGHT_PX = 48
